import React from 'react';
import {withRouter} from "react-router-dom";
import {withToastManager} from "react-toast-notifications";

function FacebookButton(props) {
    function handleFacebookLogin() {
        const {toastManager} = props;
        if (window.FB) {
            window.FB.login((facebookResponse) => {
                if (typeof facebookResponse === "undefined") {
                    toastManager.add("Error with Facebook login, user not connected to Facebook!", {
                        appearance: 'error'
                    });
                    return;
                }

                if (facebookResponse.status === "unknown") {
                    // FB access canceled by user via button
                    if (typeof facebookResponse.authResponse === "undefined") {
                        props.history.goBack();
                        return ;
                    }
                    else {
                        // FB access popup closed by user or other unknown error
                        toastManager.add("Please try to authenticate again with Facebook or use another authentication method.", {
                            appearance: 'error'
                        });
                        return;
                    }
                }

                if (facebookResponse.authResponse) {
                    var goToLink = "/social-auth?state=facebook";
                    if (facebookResponse.authResponse.accessToken) {
                        goToLink += "&fbToken=" + facebookResponse.authResponse.accessToken;
                    }
                    props.history.push(goToLink);
                } else {
                    toastManager.add("Error with Facebook login, user not connected to Facebook!", {
                        appearance: 'error'
                    });
                }
            }, {scope: "public_profile,email"});
        }
    }

    return (
        <a href="javascript:void(0);" onClick={handleFacebookLogin}> <img src="assets/img/login_page/fb.png" alt=""/> </a>
    );
}

export default withToastManager(withRouter(FacebookButton));